module.exports = __webpack_public_path__ + "img/2012-04-10 19.54.25.a70de8b7.jpg";